import axios from 'axios';
import { useContext, useMemo } from 'react';

import { AppContext } from '@/components/providers/app/app-context';
import { HttpContext } from '@/components/providers/http/http-context';
import { HttpProviderContext } from '@/components/providers/http/useHttpProvider';
import { USER_AGENT, VITE_URL_SERVICE } from '@/utils/envs';

export function useApp() {
  return useContext(AppContext);
}

export function useHttp(): HttpProviderContext {
  const context = useContext(HttpContext) as unknown as HttpProviderContext;

  const modifiedContext = useMemo(() => {
    // Creamos una instancia de Axios limpia que NO inyecta el token de Auth0.
    // Esto evita que el backend choque intentando validar el token hacia Izzi.
    const cleanHttp = axios.create({
      baseURL: VITE_URL_SERVICE,
      headers: {
        'User-Agent': USER_AGENT,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    return { ...context, http: cleanHttp };
  }, [context]);

  return modifiedContext;
}
